import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { Grid } from '@splidejs/splide-extension-grid';

/**
 * Initializes carousels for data and logo blocks.
 */
function initCarousels() {
	const dataCarousels = document.querySelectorAll('.data-carousel .splide');
	const logoCarousels = document.querySelectorAll('.logo-carousel .splide');

	dataCarousels.forEach((carousel) => {
		const splide = new Splide(carousel, {
			type: 'loop',
			perPage: 3,
			perMove: 1,
			pagination: false,
			gap: '30px',
			breakpoints: {
				991: {
					gap: '15px',
				},
				767: {
					perPage: 2,
				},
				479: {
					perPage: 1,
				},
			},
		});

		splide.mount();
	});

	logoCarousels.forEach((carousel) => {
		const splide = new Splide(carousel, {
			type: 'loop',
			pagination: false,
			gap: '30px',
			interval: 5000,
			speed: 1000,
			easing: 'linear',
			autoplay: true,
			grid: {
				rows: 2,
				cols: 4,
				gap: {
					col: '15px',
					row: '15px',
				},
			},
			breakpoints: {
				767: {
					grid: {
						cols: 3,
					},
				},
				480: {
					grid: {
						cols: 2,
					},
				},
			},
		});

		splide.mount({ Grid });
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initCarousels();

	if (window.acf) {
		window.acf.addAction('render_block_preview/type=datakaruselli', initCarousels);
		window.acf.addAction('render_block_preview/type=logokaruselli', initCarousels);
	}
});
